import React from "react"
import { Link } from "react-router-dom"

const WaitlistLink = () => ( 
  <div className="menu-button">
    <Link className="waitlist" to="/settings/waitlists">Waitlists</Link>
  </div>
)

export default WaitlistLink